import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { contactApi } from "../api/contactApi";

export default function ContactDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await contactApi.get(id);
      setItem(res.data || null);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
      setItem(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id]);

  const setRead = async (isRead) => {
    try {
      await contactApi.setRead(id, isRead);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Update failed");
    }
  };

  if (loading) return <div className="card"><div className="cardBody">Yüklənir...</div></div>;
  if (err) return <div className="card"><div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>{String(err)}</div></div>;
  if (!item) return null;

  return (
    <div>
      <h1 className="pageTitle">Mesaj{id}</h1>

      <div className="card" style={{ marginBottom: 12 }}>
        <div className="cardBody" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button className="btn" onClick={() => nav(-1)}>← Back</button>
          <button className="btn btnPrimary" onClick={() => setRead(true)} disabled={item.isRead}>Mark Read</button>
          <button className="btn btnDanger" onClick={() => setRead(false)} disabled={!item.isRead}>Mark Unread</button>
          <a className="btn" href={`mailto:${item.email}?subject=Re:%20Contact%20Message%20${item.id}`}>Reply Email</a>
        </div>
      </div>

      <div className="card">
        <div className="cardBody">
          <div style={{ display: "grid", gap: 8 }}>
            <div><b>Tarix:</b> {new Date(item.createDateUtc).toLocaleString()}</div>
            <div><b>Ad:</b> {item.name}</div>
            <div><b>Email:</b> {item.email}</div>
            <div><b>Status:</b> {item.isRead ? "Read" : "New"}</div>
            <hr />
            <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
              {item.message}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
